import { AccountInterface } from 'starknet';
import { Asset } from '../interfaces';
import { NostraInterestTokenContract } from '../services/contracts/NostraInterestTokenContract';
import { NostraTokenContract } from '../services/contracts/NostraTokenContract';

export function getNostraContract(
  asset: Asset,
  nostraToken: string,
  account: AccountInterface,
): NostraInterestTokenContract | NostraTokenContract {
  if (
    nostraToken === asset.nostraInterestBearingTokenAddress ||
    nostraToken === asset.nostraInterestBearingCollateralTokenAddress
  ) {
    return new NostraInterestTokenContract(asset.tokenPrecision, nostraToken, account);
  }

  return new NostraTokenContract(asset.tokenPrecision, nostraToken, account);
}
